import { api } from '@/api/ApiGateway'

class UserAdminApi
{
	delete(userId, onSuccess, onError)
	{
		api.delete(`users/${userId}`).then(response =>
		{
			if (response.hasError())
			{
				onError(response)
				return
			}
			try
			{
				onSuccess(response.body()?.data)
			}
			catch (e)
			{
				response.overrideError({ detail: `${e}` })
				onError(response)
			}
		})
	}

	get(userId, sortBy, onSuccess, onError)
	{
		api.get(`user/${userId}`, {
			sort: sortBy
		}).then(response =>
		{
			if (response.hasError())
			{
				onError(response)
				return
			}
			if (!response.body()?.data)
			{
				response.overrideError({ detail: 'Error loading user data.' })
				onError(response)
				return
			}

			onSuccess(response.body()?.data)
		})
	}

	update(userData, onSuccess, onError)
	{
		api.patch('users/user', userData).then(response =>
		{
			if (response.hasError())
			{
				onError(response)
				return
			}
			try
			{
				onSuccess(response)
			}
			catch (e)
			{
				response.overrideError({ detail: `${e}` })
				onError(response)
			}
		})
	}

	restore(userId, onSuccess, onError)
	{
		api.get(`users/restore/${userId}`).then(response =>
		{
			if (response.hasError())
			{
				onError(response)
				return
			}
			if (!response.body()?.data)
			{
				response.overrideError({ detail: 'Error restoring user data.' })
				onError(response)
				return
			}

			onSuccess(response.body()?.data)
		})
	}

	/**
	 * Gets a list of users that have a role marked with a point of contact
	 * @param onSuccess
	 * @param onError
	 */
	getPointsOfContact(onSuccess, onError)
	{
		api.get(`users/points-of-contact`).then(response =>
		{
			if (response.hasError())
			{
				onError(response)
				return
			}
			if (!response.body()?.data)
			{
				response.overrideError({ detail: 'Error getting points of contact.' })
				onError(response)
				return
			}

			onSuccess(response.body()?.data)
		})
	}

	/**
	 * Sends invites for emails entered in invite modal
	 * @param {Array<object>} users Array of emails and organizations
	 * @param {function} onSuccess Function called when request succeeds
	 * @param {function} onError Function called when request fails
	 */
	sendInvites(users, onSuccess, onError)
	{
		api.post('users/invite', users).then(response =>
		{
			if (response.hasError())
			{
				onError(response)
				return
			}

			onSuccess(response.body())
		})
	}

	/**
	 * Resends the selected invites.
	 * @param {Array<number>} p_invite_ids Array of invite ids
	 * @param {function} onSuccess Function called when request succeeds
	 * @param {function} onError Function called when request fails
	 */
	resendInvites(p_invite_ids, onSuccess, onError)
	{
		api.post('users/resend-invite', {invite_ids:p_invite_ids}).then(response =>
		{
			if (response.hasError())
			{
				onError(response)
				return
			}

			onSuccess(response.body())
		})
	}

	/**
	 * Deletes the selected invites.
	 * @param {Array<number>} p_invite_ids Array of invite ids
	 * @param {function} onSuccess Function called when request succeeds
	 * @param {function} onError Function called when request fails
	 */
	deleteInvites(p_invite_ids, onSuccess, onError)
	{
		api.delete('users/invite/delete', {invite_ids:p_invite_ids}).then(response =>
		{
			if (response.hasError())
			{
				onError(response)
				return
			}

			onSuccess(response.body())
		})
	}
}

export const userAdminApi = new UserAdminApi()